var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styled_components_1 = require("styled-components");
var colorByNotificationType = function (colors, type) {
    return colors[type] || colors.accent;
};
var Item = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    margin-top: 9px;\n    font-size: 13px;\n    border-radius: 1px;\n    padding: 7px 12px 7px 15px;\n    background: ", ";\n    color: ", ";\n    ", "\n    \n    &:before {\n        content: \"\";\n        position: absolute;\n        width: 3px;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        background: ", ";\n    }\n"], ["\n    position: relative;\n    margin-top: 9px;\n    font-size: 13px;\n    border-radius: 1px;\n    padding: 7px 12px 7px 15px;\n    background: ", ";\n    color: ", ";\n    ", "\n    \n    &:before {\n        content: \"\";\n        position: absolute;\n        width: 3px;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        background: ", ";\n    }\n"])), function (props) { return props.theme.notifications.item.background || 'transparent'; }, function (props) { return props.theme.notifications.item.color || 'inherit'; }, function (props) { return props.theme.notifications.item.css; }, function (props) { return colorByNotificationType(props.theme.colors, props.type); });
var NotificationsItem = /** @class */ (function (_super) {
    __extends(NotificationsItem, _super);
    function NotificationsItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificationsItem.prototype.render = function () {
        var notification = this.props.notification;
        return (React.createElement(Item, { type: notification.type }, notification.content));
    };
    return NotificationsItem;
}(React.Component));
exports.default = NotificationsItem;
var templateObject_1;
